import { render } from "./ChatInteractive.vue?vue&type=template&id=1ef03c08&scoped=true"
import script from "./ChatInteractive.vue?vue&type=script&lang=js"
export * from "./ChatInteractive.vue?vue&type=script&lang=js"

import "./ChatInteractive.vue?vue&type=style&index=0&id=1ef03c08&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef03c08"]])

export default __exports__